export const COMPONENT_NAME_PREFIX = 'forge-';
